
import React from 'react'

import {
	InsightsLink,
	PlainWrap,
	InsightLabel,
	InsightIcon,
	Arrow,
	PlainIconWhite,
	ArrowWhite,
	PlainRow,
	PlainCol,
	PlainImg,
	PlainImgMobile,
	ArticleCardLink, InsightTextLink
} from './elements'

import {
	BodySm,
	TitleXs,
	Desktop,
	Mobile
} from 'components/elements'
import {smartTruncate} from "../../generalHelpers";

const icons = {
	'PressRelease': 'images/PressRelease-icon-black.svg',
	'Podcast': 'images/Podcast-icon-black.svg',
	'Event': 'images/Event-icon-black.svg',
	'BlogPost': 'images/BlogPost-icon-black.svg'
}

function Plain(props) {
	return (
		<PlainRow className={props.reverse ? "reverse" : ""}
			borderTop={props.borderTop}
			borderRight={props.borderRight}
			borderBottom={props.borderBottom}
			borderLeft={props.borderLeft}
			height={props.height}
		>

			{ props.link ?
				props.type !== "News" ?
					<InsightTextLink className="article card" to={props.link} />

					: <ArticleCardLink className="article card" href={props.link} rel="noopener noreferrer" target={props.offPageLink ? '_blank' : '_self'} />
				: ''}
			{
				props.image ?
					<PlainCol>
						<Desktop>
							<PlainImg src={props.image} />
						</Desktop>
						<Mobile>
							<PlainImgMobile src={props.mobileImage} />
						</Mobile>
					</PlainCol> : ''
			}
			<PlainCol>
				<PlainWrap
					backgroundColor={props.backgroundColor}
					hoverBg={props.hoverBg}
					padding={props.padding}
				>
					<InsightLabel className="article type">
						<InsightIcon type={props.type} src={icons[props.type]} />
						<PlainIconWhite type={props.type} src={props.iconWhite} />
						<BodySm textTransform="uppercase">{props.label}</BodySm>
					</InsightLabel>
					
					<TitleXs height={props.height} lineHeihgt="1.3" className="article title">{smartTruncate(props.description,120)}</TitleXs>

					{
						props.type === "News" ?
							<a className="article link" href={props.link ? props.link : "#"} rel="noopener noreferrer" target="_blank">
								<Arrow src="/images/arrow_news.svg" alt="Arrow go to page"/>
								<ArrowWhite src="/images/arrow_news-white.svg" alt="Arrow go to page"/>
							</a>
							: <InsightsLink className="article link" to={props.link ? props.link : "#"}>{props.ctaText ? props.ctaText : 'Read More'}</InsightsLink>

					}
				</PlainWrap>
			</PlainCol>
		</PlainRow>
	)
}

export default Plain

